import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";

export type PublicPortfolioItem = {
  id: string;
  title: string;
  tag: string;
  image_url: string;
  external_url: string | null;
  sort_order: number;
};

export const getPublicPortfolio = createServerFn({ method: "GET" }).handler(
  async () => {
    const url = process.env.SUPABASE_URL;
    const key = process.env.SUPABASE_PUBLISHABLE_KEY;
    if (!url || !key) return { items: [] as PublicPortfolioItem[] };

    const supabase = createClient(url, key, {
      auth: { persistSession: false, autoRefreshToken: false },
    });

    const { data, error } = await supabase
      .from("portfolio_items")
      .select("id, title, tag, image_url, external_url, sort_order")
      .eq("is_visible", true)
      .order("sort_order", { ascending: true })
      .order("created_at", { ascending: true });

    if (error) {
      console.error("getPublicPortfolio failed", error);
      return { items: [] as PublicPortfolioItem[] };
    }
    return { items: (data ?? []) as PublicPortfolioItem[] };
  },
);
